import React, { Component } from 'react'
import { fetchEventList } from 'src/actions'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EventCard from '../EventCard/EventCard'
import LogoRectangle from 'assets/icons//logo-rectangle.png'
import appleIcon from 'assets/icons/apple-icon-white.png'
import Button from 'src/components/common/Button'
import { appUrl } from 'containers/time-poll/constants'
import HobnobModal from 'components/common/HobnobModal'

import styles from './event-panel.scss'

class EventPanel extends Component {
  state = {
    eventList: [],
    pageInfo: null,
    showDownloadModal: false
  }
  scrollLeft = 0
  componentDidMount() {
    this.onLoadEventList()
  }

  onLoadEventList = (after = null) => {
    const { type, getEventList } = this.props
    getEventList({
      after,
      types: type === 'active' ? 'hosted_by,invited_to,community_discoverable' : 'draft',
      onSuccessCallback: data => {
        if (data.data.me?.events_connection) {
          let activeEvents

          if (type === 'active') {
            activeEvents = data.data.me?.events_connection.events.filter(
              item => item.state === 'active' && !item.archived_at && !item.destroyed_at
            )
          } else {
            activeEvents = data.data.me?.events_connection.events
          }

          const new_eventList = this.state.eventList.concat(activeEvents)

          this.setState(
            {
              eventList: new_eventList,
              pageInfo: data.data.me?.events_connection.page_info
            },
            () => {
              if (
                new_eventList.length < 6 &&
                data.data.me?.events_connection.page_info.has_next_page
              ) {
                this.onLoadEventList(
                  data.data.me?.events_connection.page_info.end_cursor?.slice(0, -3)
                )
              }
            }
          )
        }
      }
    })
  }

  handleScroll = e => {
    const { scrollTop, clientHeight, scrollHeight, scrollLeft } = e.target

    if (this.scrollLeft !== scrollLeft) {
      this.scrollLeft = scrollLeft
      return
    }

    const {
      pageInfo: { has_next_page, end_cursor }
    } = this.state
    if (scrollTop + clientHeight === scrollHeight && has_next_page) {
      this.onLoadEventList(end_cursor.slice(0, -3))
    }
  }

  handleDelete = eventId => {
    const { eventList } = this.state
    const index = eventList.findIndex(item => item.id === eventId)

    eventList.splice(index, 1)

    this.setState({ eventList })
  }

  render() {
    const { eventList, showDownloadModal } = this.state
    return (
      <div className={styles['event-panel']} onScroll={this.handleScroll}>
        <ul className={styles['event-wrapper']}>
          {eventList.map((event, index) => (
            <EventCard
              key={index}
              event={event}
              onDeleteEventCallback={this.handleDelete}
              onShowDownLoad={() => this.setState({ showDownloadModal: true })}
            />
          ))}
        </ul>
        <HobnobModal
          show={showDownloadModal}
          showCancelIcon={false}
          onClose={() => this.setState({ showDownloadModal: false })}
          containerClassName={styles['download-container']}
        >
          <div className={styles['download-wrapper']}>
            <img src={LogoRectangle} alt="" />
            <div className={styles['text']}>This feature is available when you use the app!</div>
            <a href={appUrl} target="_blank" rel="noreferrer" className={styles['link']}>
              <Button onClick={() => {}} className={styles['button-inner']}>
                <img src={appleIcon} />
                <strong>Download Hobnob on App Store</strong>
              </Button>
            </a>
            <div
              className={styles['close-text']}
              onClick={() => this.setState({ showDownloadModal: false })}
            >
              No, Thanks
            </div>
          </div>
        </HobnobModal>
      </div>
    )
  }
}

EventPanel.defaultProps = {
  type: 'active'
}

EventPanel.propTypes = {
  getEventList: PropTypes.func,
  type: PropTypes.string
}

function mapStateToProps(state) {
  return {
    eventsTab: state.frontend.eventsTab
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getEventList: params => dispatch(fetchEventList(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPanel)



// WEBPACK FOOTER //
// ./src/containers/event/EventList/EventPanel/EventPanel.jsx